import personSaga from "./person/personSaga";
import {all} from "redux-saga/effects";

export default function* rootSaga() {
    yield all([
        personSaga()
    ])
}